import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Button,
  Divider,
  Table,
  TableCell,
  TableHead,
  TableRow,
  TableBody,
  CircularProgress,
  Snackbar,
} from "@material-ui/core";
import { Alert } from "@mui/material";
import React, { useState } from "react";
import { config } from "../../config/config";

const CreateTicketModal = (props) => {
  const [formData, setFormData] = useState({});

  const [disabled, setButtonDisabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: "info", message: "" });
  const [showAlert, setShowAlert] = useState(false);

  const handleFormChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      deployments: props.releases.filter(
        (item, pos, self) => self.indexOf(item) === pos
      ),
      [e.target.name]: e.target.value,
    }));
  };

  const handleNotificationClose = () => {
    setShowAlert(false);
    setMessage({ type: "info", message: "" });
  };

  const deleteFromTable = (e) => {
    console.log("Remove");
  };
  const createReleaseTicket = (e) => {
    e.preventDefault();
    setButtonDisabled(true);
    setLoading(true);
    console.log(formData);

    let headers = {
      "Content-Type": "application/json",
    };
    fetch(`${config.API_URL}/Release/ticket`, {
      method: "POST",
      body: JSON.stringify(formData),
      headers: headers,
    })
      .then((res) => {
        if (res.ok) {
          setLoading(false);
          setButtonDisabled(false);
          props.handleClose(true);
          return res.json();
        } else {
          setLoading(false);
          setButtonDisabled(false);
          console.log(res);
          setMessage({
            type: "error",
            message: `Failed to create release ticket. Status Code: ${res.status}`,
          });
          setShowAlert(true);
        }
      })
      .then((data) => {
        console.log(data);
        setMessage({
          type: "success",
          message: `Successfully created ticket ${data.key}`,
        });
        setShowAlert(true);
        setFormData({
          deployments: props.releases.filter(
            (item, pos, self) => self.indexOf(item) === pos
          ),
        });
      });
  };

  return (
    <div>
      <Dialog open={props.open} onClose={props.handleClose}>
        <DialogTitle>Create Release Ticket</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Fill out the below form to create this release ticket. The table
            below contains the specified releases.
          </DialogContentText>
          <Box component="form">
            <TextField
              autoFocus
              margin="dense"
              id="summary"
              name="summary"
              label="Title"
              type="text"
              required
              fullWidth
              variant="standard"
              onChange={handleFormChange}
            />
            <TextField
              margin="dense"
              id="projectKey"
              name="projectKey"
              label="Project Key (i.e CC)"
              type="text"
              fullWidth
              required
              variant="standard"
              onChange={handleFormChange}
            />
            <Divider />
            {props.releases !== undefined && props.releases.length > 0 && (
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>{"Remove?"}</TableCell>
                    <TableCell>{"Project"}</TableCell>
                    <TableCell>{"Application"}</TableCell>
                    <TableCell>{"Version"}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {props.releases !== undefined &&
                    props.releases
                      .filter((item, pos, self) => self.indexOf(item) === pos)
                      .map((r, i) => {
                        return (
                          <TableRow key={i}>
                            <TableCell>
                              <Button
                                disabled
                                onClick={(e) => deleteFromTable(e)}
                              >
                                X
                              </Button>
                            </TableCell>
                            <TableCell>{r.project}</TableCell>
                            <TableCell>{r.app_name}</TableCell>
                            <TableCell>{r.version_num}</TableCell>
                          </TableRow>
                        );
                      })}
                </TableBody>
              </Table>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={props.handleClose}>Cancel</Button>
          <Button disable={disabled} onClick={(e) => createReleaseTicket(e)}>
            {!loading ? "Create" : <CircularProgress />}
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={showAlert}
        autoHideDuration={10000}
        onClose={handleNotificationClose}
      >
        <Alert severity={message.type} sx={{ width: "100%" }}>
          {message.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default CreateTicketModal;
